// This file is auto-generated by @hey-api/openapi-ts

import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { deleteApiShipmentsByIdDelay, getApiCustomerOrders, getApiCustomerOrdersById, getApiPartners, getApiPartnersById, getApiPartnersByIdContracts, getApiPartnersByIdCounterparties, getApiPartnersByIdDeliveryAddress, getApiPartnersByIdLastContract, getApiPartnersByIdLastPrices, getApiPartnersByIdLastWarehouse, getApiProducts, getApiProductsGroups, getApiSampleTests, getApiSettingsPlanning, getApiShipments, getApiShipmentsById, getApiShipmentsByIdInvoice, getApiShipmentsByIdVolumeAnalysis, getApiShipmentsTaskSummary, getApiSystemVersion, getApiWarehouses, getApiWarehousesByIdAvailableStock, type Options, postApiSampleTestsByIdFail, postApiSampleTestsByIdReopen, postApiSampleTestsByIdSucceed, postApiShipments, postApiShipmentsByIdCancel, postApiShipmentsByIdDelay, postApiShipmentsByIdHandover, postApiShipmentsByIdHandoverRequestOutcome, postApiShipmentsByIdReturnToPlan, postApiShipmentsByIdReturnToPreparation, postApiShipmentsByIdSendToDelivery, postApiShipmentsByIdTakeIntoWork, postApiShipmentsForecast, postApiShipmentsFromForecast, putApiPartnersByIdPaymentTerms, putApiPartnersByIdPlanning, putApiSampleTestsByIdSchedule, putApiSettingsPlanning, putApiShipmentsById, putApiShipmentsByIdApprovalSteps, putApiShipmentsByIdDelivery, putApiShipmentsByIdDocuments, putApiShipmentsByIdNextShipmentIntervals } from '../sdk.gen';
import type { DeleteApiShipmentsByIdDelayData, DeleteApiShipmentsByIdDelayError, DeleteApiShipmentsByIdDelayResponse, GetApiCustomerOrdersByIdData, GetApiCustomerOrdersByIdError, GetApiCustomerOrdersByIdResponse, GetApiCustomerOrdersData, GetApiCustomerOrdersError, GetApiCustomerOrdersResponse, GetApiPartnersByIdContractsData, GetApiPartnersByIdContractsError, GetApiPartnersByIdContractsResponse, GetApiPartnersByIdCounterpartiesData, GetApiPartnersByIdCounterpartiesError, GetApiPartnersByIdCounterpartiesResponse, GetApiPartnersByIdData, GetApiPartnersByIdDeliveryAddressData, GetApiPartnersByIdDeliveryAddressError, GetApiPartnersByIdDeliveryAddressResponse, GetApiPartnersByIdError, GetApiPartnersByIdLastContractData, GetApiPartnersByIdLastContractError, GetApiPartnersByIdLastContractResponse, GetApiPartnersByIdLastPricesData, GetApiPartnersByIdLastPricesError, GetApiPartnersByIdLastPricesResponse, GetApiPartnersByIdLastWarehouseData, GetApiPartnersByIdLastWarehouseError, GetApiPartnersByIdLastWarehouseResponse, GetApiPartnersByIdResponse, GetApiPartnersData, GetApiPartnersError, GetApiPartnersResponse, GetApiProductsData, GetApiProductsError, GetApiProductsGroupsData, GetApiProductsGroupsError, GetApiProductsGroupsResponse, GetApiProductsResponse, GetApiSampleTestsData, GetApiSampleTestsError, GetApiSampleTestsResponse, GetApiSettingsPlanningData, GetApiSettingsPlanningError, GetApiSettingsPlanningResponse, GetApiShipmentsByIdData, GetApiShipmentsByIdError, GetApiShipmentsByIdInvoiceData, GetApiShipmentsByIdInvoiceError, GetApiShipmentsByIdInvoiceResponse, GetApiShipmentsByIdResponse, GetApiShipmentsByIdVolumeAnalysisData, GetApiShipmentsByIdVolumeAnalysisError, GetApiShipmentsByIdVolumeAnalysisResponse, GetApiShipmentsData, GetApiShipmentsError, GetApiShipmentsResponse, GetApiShipmentsTaskSummaryData, GetApiShipmentsTaskSummaryError, GetApiShipmentsTaskSummaryResponse, GetApiSystemVersionData, GetApiSystemVersionError, GetApiSystemVersionResponse, GetApiWarehousesByIdAvailableStockData, GetApiWarehousesByIdAvailableStockError, GetApiWarehousesByIdAvailableStockResponse, GetApiWarehousesData, GetApiWarehousesError, GetApiWarehousesResponse, PostApiSampleTestsByIdFailData, PostApiSampleTestsByIdFailError, PostApiSampleTestsByIdFailResponse, PostApiSampleTestsByIdReopenData, PostApiSampleTestsByIdReopenError, PostApiSampleTestsByIdReopenResponse, PostApiSampleTestsByIdSucceedData, PostApiSampleTestsByIdSucceedError, PostApiSampleTestsByIdSucceedResponse, PostApiShipmentsByIdCancelData, PostApiShipmentsByIdCancelError, PostApiShipmentsByIdCancelResponse, PostApiShipmentsByIdDelayData, PostApiShipmentsByIdDelayError, PostApiShipmentsByIdDelayResponse, PostApiShipmentsByIdHandoverData, PostApiShipmentsByIdHandoverError, PostApiShipmentsByIdHandoverRequestOutcomeData, PostApiShipmentsByIdHandoverRequestOutcomeError, PostApiShipmentsByIdHandoverRequestOutcomeResponse, PostApiShipmentsByIdHandoverResponse, PostApiShipmentsByIdReturnToPlanData, PostApiShipmentsByIdReturnToPlanError, PostApiShipmentsByIdReturnToPlanResponse, PostApiShipmentsByIdReturnToPreparationData, PostApiShipmentsByIdReturnToPreparationError, PostApiShipmentsByIdReturnToPreparationResponse, PostApiShipmentsByIdSendToDeliveryData, PostApiShipmentsByIdSendToDeliveryError, PostApiShipmentsByIdSendToDeliveryResponse, PostApiShipmentsByIdTakeIntoWorkData, PostApiShipmentsByIdTakeIntoWorkError, PostApiShipmentsByIdTakeIntoWorkResponse, PostApiShipmentsData, PostApiShipmentsError, PostApiShipmentsForecastData, PostApiShipmentsForecastError, PostApiShipmentsForecastResponse, PostApiShipmentsFromForecastData, PostApiShipmentsFromForecastError, PostApiShipmentsFromForecastResponse, PostApiShipmentsResponse, PutApiPartnersByIdPaymentTermsData, PutApiPartnersByIdPaymentTermsError, PutApiPartnersByIdPaymentTermsResponse, PutApiPartnersByIdPlanningData, PutApiPartnersByIdPlanningError, PutApiPartnersByIdPlanningResponse, PutApiSampleTestsByIdScheduleData, PutApiSampleTestsByIdScheduleError, PutApiSampleTestsByIdScheduleResponse, PutApiSettingsPlanningData, PutApiSettingsPlanningError, PutApiSettingsPlanningResponse, PutApiShipmentsByIdApprovalStepsData, PutApiShipmentsByIdApprovalStepsError, PutApiShipmentsByIdApprovalStepsResponse, PutApiShipmentsByIdData, PutApiShipmentsByIdDeliveryData, PutApiShipmentsByIdDeliveryError, PutApiShipmentsByIdDeliveryResponse, PutApiShipmentsByIdDocumentsData, PutApiShipmentsByIdDocumentsError, PutApiShipmentsByIdDocumentsResponse, PutApiShipmentsByIdError, PutApiShipmentsByIdNextShipmentIntervalsData, PutApiShipmentsByIdNextShipmentIntervalsError, PutApiShipmentsByIdNextShipmentIntervalsResponse, PutApiShipmentsByIdResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getApiCustomerOrdersQueryKey = (options?: Options<GetApiCustomerOrdersData>) => createQueryKey('getApiCustomerOrders', options);

/**
 * Возвращает страницу заказов клиентов; по умолчанию - действующих, новые сверху.
 */
export const getApiCustomerOrdersOptions = (options?: Options<GetApiCustomerOrdersData>) => queryOptions<GetApiCustomerOrdersResponse, GetApiCustomerOrdersError, GetApiCustomerOrdersResponse, ReturnType<typeof getApiCustomerOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiCustomerOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiCustomerOrdersQueryKey(options)
});

export const getApiCustomerOrdersByIdQueryKey = (options: Options<GetApiCustomerOrdersByIdData>) => createQueryKey('getApiCustomerOrdersById', options);

/**
 * Возвращает карточку заказа клиента со строками.
 */
export const getApiCustomerOrdersByIdOptions = (options: Options<GetApiCustomerOrdersByIdData>) => queryOptions<GetApiCustomerOrdersByIdResponse, GetApiCustomerOrdersByIdError, GetApiCustomerOrdersByIdResponse, ReturnType<typeof getApiCustomerOrdersByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiCustomerOrdersById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiCustomerOrdersByIdQueryKey(options)
});

export const getApiPartnersQueryKey = (options?: Options<GetApiPartnersData>) => createQueryKey('getApiPartners', options);

/**
 * Возвращает страницу партнёров; по умолчанию - действующих клиентов.
 */
export const getApiPartnersOptions = (options?: Options<GetApiPartnersData>) => queryOptions<GetApiPartnersResponse, GetApiPartnersError, GetApiPartnersResponse, ReturnType<typeof getApiPartnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPartners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersQueryKey(options)
});

export const getApiPartnersByIdQueryKey = (options: Options<GetApiPartnersByIdData>) => createQueryKey('getApiPartnersById', options);

/**
 * Возвращает партнёра по идентификатору.
 */
export const getApiPartnersByIdOptions = (options: Options<GetApiPartnersByIdData>) => queryOptions<GetApiPartnersByIdResponse, GetApiPartnersByIdError, GetApiPartnersByIdResponse, ReturnType<typeof getApiPartnersByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPartnersById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersByIdQueryKey(options)
});

export const getApiPartnersByIdCounterpartiesQueryKey = (options: Options<GetApiPartnersByIdCounterpartiesData>) => createQueryKey('getApiPartnersByIdCounterparties', options);

/**
 * Возвращает действующих контрагентов партнёра.
 */
export const getApiPartnersByIdCounterpartiesOptions = (options: Options<GetApiPartnersByIdCounterpartiesData>) => queryOptions<GetApiPartnersByIdCounterpartiesResponse, GetApiPartnersByIdCounterpartiesError, GetApiPartnersByIdCounterpartiesResponse, ReturnType<typeof getApiPartnersByIdCounterpartiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPartnersByIdCounterparties({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersByIdCounterpartiesQueryKey(options)
});

export const getApiPartnersByIdContractsQueryKey = (options: Options<GetApiPartnersByIdContractsData>) => createQueryKey('getApiPartnersByIdContracts', options);

/**
 * Возвращает договоры клиента, годные для выбора в отгрузке.
 *
 * Договоры с клиентом, действующие в 1С, на действующего контрагента клиента; по наименованию.
 */
export const getApiPartnersByIdContractsOptions = (options: Options<GetApiPartnersByIdContractsData>) => queryOptions<GetApiPartnersByIdContractsResponse, GetApiPartnersByIdContractsError, GetApiPartnersByIdContractsResponse, ReturnType<typeof getApiPartnersByIdContractsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPartnersByIdContracts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersByIdContractsQueryKey(options)
});

export const getApiPartnersByIdLastContractQueryKey = (options: Options<GetApiPartnersByIdLastContractData>) => createQueryKey('getApiPartnersByIdLastContract', options);

/**
 * Возвращает договор, который форма отгрузки подставляет клиенту, - подсказку для договора отгрузки.
 *
 * Договор прошлого заказа клиента с этого склада, без него - прошлого заказа клиента, без него - единственный
 * договор; только годный для заказа. Подсказки нет - поля ответа пустые.
 */
export const getApiPartnersByIdLastContractOptions = (options: Options<GetApiPartnersByIdLastContractData>) => queryOptions<GetApiPartnersByIdLastContractResponse, GetApiPartnersByIdLastContractError, GetApiPartnersByIdLastContractResponse, ReturnType<typeof getApiPartnersByIdLastContractQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPartnersByIdLastContract({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersByIdLastContractQueryKey(options)
});

export const getApiPartnersByIdLastPricesQueryKey = (options: Options<GetApiPartnersByIdLastPricesData>) => createQueryKey('getApiPartnersByIdLastPrices', options);

/**
 * Возвращает прошлую цену клиента по продуктам - подсказку для строки отгрузки.
 *
 * Продукта, который клиент не брал, в ответе нет.
 */
export const getApiPartnersByIdLastPricesOptions = (options: Options<GetApiPartnersByIdLastPricesData>) => queryOptions<GetApiPartnersByIdLastPricesResponse, GetApiPartnersByIdLastPricesError, GetApiPartnersByIdLastPricesResponse, ReturnType<typeof getApiPartnersByIdLastPricesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPartnersByIdLastPrices({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersByIdLastPricesQueryKey(options)
});

export const getApiPartnersByIdLastWarehouseQueryKey = (options: Options<GetApiPartnersByIdLastWarehouseData>) => createQueryKey('getApiPartnersByIdLastWarehouse', options);

/**
 * Возвращает склад прошлого заказа клиента - подсказку для склада отгрузки.
 *
 * Подсказки нет - поля ответа пустые.
 */
export const getApiPartnersByIdLastWarehouseOptions = (options: Options<GetApiPartnersByIdLastWarehouseData>) => queryOptions<GetApiPartnersByIdLastWarehouseResponse, GetApiPartnersByIdLastWarehouseError, GetApiPartnersByIdLastWarehouseResponse, ReturnType<typeof getApiPartnersByIdLastWarehouseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPartnersByIdLastWarehouse({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersByIdLastWarehouseQueryKey(options)
});

export const getApiPartnersByIdDeliveryAddressQueryKey = (options: Options<GetApiPartnersByIdDeliveryAddressData>) => createQueryKey('getApiPartnersByIdDeliveryAddress', options);

/**
 * Возвращает адрес доставки по умолчанию для новой отгрузки клиента.
 *
 * Адрес последнего заказа клиента, без него - адрес партнёра; подсказки нет - поля ответа пустые.
 */
export const getApiPartnersByIdDeliveryAddressOptions = (options: Options<GetApiPartnersByIdDeliveryAddressData>) => queryOptions<GetApiPartnersByIdDeliveryAddressResponse, GetApiPartnersByIdDeliveryAddressError, GetApiPartnersByIdDeliveryAddressResponse, ReturnType<typeof getApiPartnersByIdDeliveryAddressQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPartnersByIdDeliveryAddress({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersByIdDeliveryAddressQueryKey(options)
});

/**
 * Исключает клиента из плана из истории или возвращает его туда.
 */
export const putApiPartnersByIdPlanningMutation = (options?: Partial<Options<PutApiPartnersByIdPlanningData>>): UseMutationOptions<PutApiPartnersByIdPlanningResponse, PutApiPartnersByIdPlanningError, Options<PutApiPartnersByIdPlanningData>> => {
    const mutationOptions: UseMutationOptions<PutApiPartnersByIdPlanningResponse, PutApiPartnersByIdPlanningError, Options<PutApiPartnersByIdPlanningData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiPartnersByIdPlanning({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Задаёт условия оплаты клиента или снимает их.
 *
 * Наши поля: в 1С условия по клиентам системно не ведутся. Процент - у частичной предоплаты, дни - у отсрочки.
 */
export const putApiPartnersByIdPaymentTermsMutation = (options?: Partial<Options<PutApiPartnersByIdPaymentTermsData>>): UseMutationOptions<PutApiPartnersByIdPaymentTermsResponse, PutApiPartnersByIdPaymentTermsError, Options<PutApiPartnersByIdPaymentTermsData>> => {
    const mutationOptions: UseMutationOptions<PutApiPartnersByIdPaymentTermsResponse, PutApiPartnersByIdPaymentTermsError, Options<PutApiPartnersByIdPaymentTermsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiPartnersByIdPaymentTerms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiProductsQueryKey = (options?: Options<GetApiProductsData>) => createQueryKey('getApiProducts', options);

/**
 * Возвращает страницу справочника продуктов.
 *
 * Успешный ответ объявлен атрибутом явно: возвращаемый тип обёрнут в
 * Result<TValue> и разворачивается фильтром
 * `TranslateResultToActionResult`, поэтому генератор OpenAPI сам вывести схему не
 * может - без атрибута в документе не будет ни ответа 200, ни схемы ProductDto,
 * и сгенерированный клиент получит нетипизированный ответ.
 */
export const getApiProductsOptions = (options?: Options<GetApiProductsData>) => queryOptions<GetApiProductsResponse, GetApiProductsError, GetApiProductsResponse, ReturnType<typeof getApiProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiProductsQueryKey(options)
});

export const getApiProductsGroupsQueryKey = (options?: Options<GetApiProductsGroupsData>) => createQueryKey('getApiProductsGroups', options);

/**
 * Возвращает группы номенклатуры, в которых есть позиции, - для фильтра справочника.
 */
export const getApiProductsGroupsOptions = (options?: Options<GetApiProductsGroupsData>) => queryOptions<GetApiProductsGroupsResponse, GetApiProductsGroupsError, GetApiProductsGroupsResponse, ReturnType<typeof getApiProductsGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiProductsGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiProductsGroupsQueryKey(options)
});

export const getApiSampleTestsQueryKey = (options?: Options<GetApiSampleTestsData>) => createQueryKey('getApiSampleTests', options);

/**
 * Возвращает страницу тестов; по умолчанию - все, ближайшие по дате теста сверху.
 *
 * «Узнать результат теста» на «Моих задачах» - `isDue=true`, счётчик - `totalRecords`.
 */
export const getApiSampleTestsOptions = (options?: Options<GetApiSampleTestsData>) => queryOptions<GetApiSampleTestsResponse, GetApiSampleTestsError, GetApiSampleTestsResponse, ReturnType<typeof getApiSampleTestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiSampleTests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiSampleTestsQueryKey(options)
});

/**
 * Переносит тест: дата теста и комментарий; статус не меняется.
 *
 * Только в «Тестируется», иначе 409 `sample_test_not_testing`. Перенесённая дата за днём отгрузки больше не следует.
 */
export const putApiSampleTestsByIdScheduleMutation = (options?: Partial<Options<PutApiSampleTestsByIdScheduleData>>): UseMutationOptions<PutApiSampleTestsByIdScheduleResponse, PutApiSampleTestsByIdScheduleError, Options<PutApiSampleTestsByIdScheduleData>> => {
    const mutationOptions: UseMutationOptions<PutApiSampleTestsByIdScheduleResponse, PutApiSampleTestsByIdScheduleError, Options<PutApiSampleTestsByIdScheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiSampleTestsByIdSchedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Закрывает тест итогом «Одобрено».
 *
 * Только из «Тестируется», иначе 409 `sample_test_not_testing`. Пустой комментарий оставляет прежний.
 */
export const postApiSampleTestsByIdSucceedMutation = (options?: Partial<Options<PostApiSampleTestsByIdSucceedData>>): UseMutationOptions<PostApiSampleTestsByIdSucceedResponse, PostApiSampleTestsByIdSucceedError, Options<PostApiSampleTestsByIdSucceedData>> => {
    const mutationOptions: UseMutationOptions<PostApiSampleTestsByIdSucceedResponse, PostApiSampleTestsByIdSucceedError, Options<PostApiSampleTestsByIdSucceedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiSampleTestsByIdSucceed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Закрывает тест итогом «Не подошло».
 *
 * Только из «Тестируется», иначе 409 `sample_test_not_testing`. Пустой комментарий оставляет прежний.
 */
export const postApiSampleTestsByIdFailMutation = (options?: Partial<Options<PostApiSampleTestsByIdFailData>>): UseMutationOptions<PostApiSampleTestsByIdFailResponse, PostApiSampleTestsByIdFailError, Options<PostApiSampleTestsByIdFailData>> => {
    const mutationOptions: UseMutationOptions<PostApiSampleTestsByIdFailResponse, PostApiSampleTestsByIdFailError, Options<PostApiSampleTestsByIdFailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiSampleTestsByIdFail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * «Вернуть в тестирование»: закрытый тест - снова в «Тестируется».
 *
 * Итог и время закрытия снимаются, комментарий и дата теста остаются. Тест в «Тестируется» - 409 `sample_test_not_closed`.
 */
export const postApiSampleTestsByIdReopenMutation = (options?: Partial<Options<PostApiSampleTestsByIdReopenData>>): UseMutationOptions<PostApiSampleTestsByIdReopenResponse, PostApiSampleTestsByIdReopenError, Options<PostApiSampleTestsByIdReopenData>> => {
    const mutationOptions: UseMutationOptions<PostApiSampleTestsByIdReopenResponse, PostApiSampleTestsByIdReopenError, Options<PostApiSampleTestsByIdReopenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiSampleTestsByIdReopen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiSettingsPlanningQueryKey = (options?: Options<GetApiSettingsPlanningData>) => createQueryKey('getApiSettingsPlanning', options);

/**
 * Возвращает настройки плана из истории; пока их не меняли - значения по умолчанию.
 */
export const getApiSettingsPlanningOptions = (options?: Options<GetApiSettingsPlanningData>) => queryOptions<GetApiSettingsPlanningResponse, GetApiSettingsPlanningError, GetApiSettingsPlanningResponse, ReturnType<typeof getApiSettingsPlanningQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiSettingsPlanning({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiSettingsPlanningQueryKey(options)
});

/**
 * Меняет настройки плана из истории: горизонт и глубину истории.
 */
export const putApiSettingsPlanningMutation = (options?: Partial<Options<PutApiSettingsPlanningData>>): UseMutationOptions<PutApiSettingsPlanningResponse, PutApiSettingsPlanningError, Options<PutApiSettingsPlanningData>> => {
    const mutationOptions: UseMutationOptions<PutApiSettingsPlanningResponse, PutApiSettingsPlanningError, Options<PutApiSettingsPlanningData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiSettingsPlanning({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiShipmentsQueryKey = (options?: Options<GetApiShipmentsData>) => createQueryKey('getApiShipments', options);

/**
 * Возвращает страницу отгрузок; по умолчанию - все, ближайшие по плановой дате сверху.
 */
export const getApiShipmentsOptions = (options?: Options<GetApiShipmentsData>) => queryOptions<GetApiShipmentsResponse, GetApiShipmentsError, GetApiShipmentsResponse, ReturnType<typeof getApiShipmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiShipments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiShipmentsQueryKey(options)
});

/**
 * Создаёт отгрузку в статусе «Запланировано»; контрагента подставляет сервер.
 */
export const postApiShipmentsMutation = (options?: Partial<Options<PostApiShipmentsData>>): UseMutationOptions<PostApiShipmentsResponse, PostApiShipmentsError, Options<PostApiShipmentsData>> => {
    const mutationOptions: UseMutationOptions<PostApiShipmentsResponse, PostApiShipmentsError, Options<PostApiShipmentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiShipments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiShipmentsByIdQueryKey = (options: Options<GetApiShipmentsByIdData>) => createQueryKey('getApiShipmentsById', options);

/**
 * Возвращает карточку отгрузки.
 */
export const getApiShipmentsByIdOptions = (options: Options<GetApiShipmentsByIdData>) => queryOptions<GetApiShipmentsByIdResponse, GetApiShipmentsByIdError, GetApiShipmentsByIdResponse, ReturnType<typeof getApiShipmentsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiShipmentsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiShipmentsByIdQueryKey(options)
});

/**
 * Правит отгрузку; строки заменяются целиком.
 */
export const putApiShipmentsByIdMutation = (options?: Partial<Options<PutApiShipmentsByIdData>>): UseMutationOptions<PutApiShipmentsByIdResponse, PutApiShipmentsByIdError, Options<PutApiShipmentsByIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiShipmentsByIdResponse, PutApiShipmentsByIdError, Options<PutApiShipmentsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiShipmentsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiShipmentsTaskSummaryQueryKey = (options?: Options<GetApiShipmentsTaskSummaryData>) => createQueryKey('getApiShipmentsTaskSummary', options);

/**
 * Возвращает сводку «Моих задач»: показатели, задачи по статусам, клиенты с задачами.
 */
export const getApiShipmentsTaskSummaryOptions = (options?: Options<GetApiShipmentsTaskSummaryData>) => queryOptions<GetApiShipmentsTaskSummaryResponse, GetApiShipmentsTaskSummaryError, GetApiShipmentsTaskSummaryResponse, ReturnType<typeof getApiShipmentsTaskSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiShipmentsTaskSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiShipmentsTaskSummaryQueryKey(options)
});

/**
 * План из истории: предложенные отгрузки по клиентам с правками менеджера; ничего не пишет.
 *
 * POST, а не GET: правки менеджера приходят телом и пересчитываются целиком.
 */
export const postApiShipmentsForecastMutation = (options?: Partial<Options<PostApiShipmentsForecastData>>): UseMutationOptions<PostApiShipmentsForecastResponse, PostApiShipmentsForecastError, Options<PostApiShipmentsForecastData>> => {
    const mutationOptions: UseMutationOptions<PostApiShipmentsForecastResponse, PostApiShipmentsForecastError, Options<PostApiShipmentsForecastData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiShipmentsForecast({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Создаёт выбранные в плане из истории отгрузки одним сохранением - все или ни одной.
 */
export const postApiShipmentsFromForecastMutation = (options?: Partial<Options<PostApiShipmentsFromForecastData>>): UseMutationOptions<PostApiShipmentsFromForecastResponse, PostApiShipmentsFromForecastError, Options<PostApiShipmentsFromForecastData>> => {
    const mutationOptions: UseMutationOptions<PostApiShipmentsFromForecastResponse, PostApiShipmentsFromForecastError, Options<PostApiShipmentsFromForecastData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiShipmentsFromForecast({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Задаёт строкам интервал до следующей отгрузки продукта - в любом статусе, кроме «Отменено».
 *
 * Интервал - данные планирования, а не поле заказа 1С: пишется и в завершённую, и в связанную с заказом отгрузку.
 */
export const putApiShipmentsByIdNextShipmentIntervalsMutation = (options?: Partial<Options<PutApiShipmentsByIdNextShipmentIntervalsData>>): UseMutationOptions<PutApiShipmentsByIdNextShipmentIntervalsResponse, PutApiShipmentsByIdNextShipmentIntervalsError, Options<PutApiShipmentsByIdNextShipmentIntervalsData>> => {
    const mutationOptions: UseMutationOptions<PutApiShipmentsByIdNextShipmentIntervalsResponse, PutApiShipmentsByIdNextShipmentIntervalsError, Options<PutApiShipmentsByIdNextShipmentIntervalsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiShipmentsByIdNextShipmentIntervals({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * «Взять в работу»: «Запланировано» -> «Согласование».
 *
 * Тем же сохранением строки с интервалом до следующей отгрузки получают следующие отгрузки
 * «Запланировано»; в карточке они видны у строк (`nextShipment`).
 */
export const postApiShipmentsByIdTakeIntoWorkMutation = (options?: Partial<Options<PostApiShipmentsByIdTakeIntoWorkData>>): UseMutationOptions<PostApiShipmentsByIdTakeIntoWorkResponse, PostApiShipmentsByIdTakeIntoWorkError, Options<PostApiShipmentsByIdTakeIntoWorkData>> => {
    const mutationOptions: UseMutationOptions<PostApiShipmentsByIdTakeIntoWorkResponse, PostApiShipmentsByIdTakeIntoWorkError, Options<PostApiShipmentsByIdTakeIntoWorkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiShipmentsByIdTakeIntoWork({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * «Назад по этапу»: «Согласование» -> «Запланировано», пока заказа в 1С нет.
 *
 * После передачи в 1С - 409 `shipment_not_in_approval`: статус ведёт заказ 1С. Отметки
 * согласования снимаются; повторное «Взять в работу» следующих отгрузок второй раз не создаёт.
 */
export const postApiShipmentsByIdReturnToPlanMutation = (options?: Partial<Options<PostApiShipmentsByIdReturnToPlanData>>): UseMutationOptions<PostApiShipmentsByIdReturnToPlanResponse, PostApiShipmentsByIdReturnToPlanError, Options<PostApiShipmentsByIdReturnToPlanData>> => {
    const mutationOptions: UseMutationOptions<PostApiShipmentsByIdReturnToPlanResponse, PostApiShipmentsByIdReturnToPlanError, Options<PostApiShipmentsByIdReturnToPlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiShipmentsByIdReturnToPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * «Передать в доставку»: «Подготовка» -> «Доставка» (ADR-013).
 *
 * Открыто, когда заказ в 1С проведён и не ждёт согласования, предоплаты или обеспечения; иначе 409
 * `shipment_delivery_not_allowed`. Трек-номер и дата отгрузки - необязательны.
 */
export const postApiShipmentsByIdSendToDeliveryMutation = (options?: Partial<Options<PostApiShipmentsByIdSendToDeliveryData>>): UseMutationOptions<PostApiShipmentsByIdSendToDeliveryResponse, PostApiShipmentsByIdSendToDeliveryError, Options<PostApiShipmentsByIdSendToDeliveryData>> => {
    const mutationOptions: UseMutationOptions<PostApiShipmentsByIdSendToDeliveryResponse, PostApiShipmentsByIdSendToDeliveryError, Options<PostApiShipmentsByIdSendToDeliveryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiShipmentsByIdSendToDelivery({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Задаёт данные доставки - трек-номер и дату отгрузки.
 *
 * На любом этапе, кроме «Отменено» (409 `shipment_cancelled`); в 1С не уходят.
 */
export const putApiShipmentsByIdDeliveryMutation = (options?: Partial<Options<PutApiShipmentsByIdDeliveryData>>): UseMutationOptions<PutApiShipmentsByIdDeliveryResponse, PutApiShipmentsByIdDeliveryError, Options<PutApiShipmentsByIdDeliveryData>> => {
    const mutationOptions: UseMutationOptions<PutApiShipmentsByIdDeliveryResponse, PutApiShipmentsByIdDeliveryError, Options<PutApiShipmentsByIdDeliveryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiShipmentsByIdDelivery({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * «Назад по этапу»: «Доставка» -> «Подготовка», пока 1С не отгрузила заказ.
 *
 * Не в «Доставке» - 409 `shipment_not_in_delivery`; заказ уже отгружен - 409
 * `shipment_order_already_shipped`.
 */
export const postApiShipmentsByIdReturnToPreparationMutation = (options?: Partial<Options<PostApiShipmentsByIdReturnToPreparationData>>): UseMutationOptions<PostApiShipmentsByIdReturnToPreparationResponse, PostApiShipmentsByIdReturnToPreparationError, Options<PostApiShipmentsByIdReturnToPreparationData>> => {
    const mutationOptions: UseMutationOptions<PostApiShipmentsByIdReturnToPreparationResponse, PostApiShipmentsByIdReturnToPreparationError, Options<PostApiShipmentsByIdReturnToPreparationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiShipmentsByIdReturnToPreparation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Отменяет отгрузку с причиной, пока в 1С нет заказа.
 */
export const postApiShipmentsByIdCancelMutation = (options?: Partial<Options<PostApiShipmentsByIdCancelData>>): UseMutationOptions<PostApiShipmentsByIdCancelResponse, PostApiShipmentsByIdCancelError, Options<PostApiShipmentsByIdCancelData>> => {
    const mutationOptions: UseMutationOptions<PostApiShipmentsByIdCancelResponse, PostApiShipmentsByIdCancelError, Options<PostApiShipmentsByIdCancelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiShipmentsByIdCancel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Снимает метку задержки.
 */
export const deleteApiShipmentsByIdDelayMutation = (options?: Partial<Options<DeleteApiShipmentsByIdDelayData>>): UseMutationOptions<DeleteApiShipmentsByIdDelayResponse, DeleteApiShipmentsByIdDelayError, Options<DeleteApiShipmentsByIdDelayData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiShipmentsByIdDelayResponse, DeleteApiShipmentsByIdDelayError, Options<DeleteApiShipmentsByIdDelayData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiShipmentsByIdDelay({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Помечает отгрузку задержанной с причиной; у задержанной меняет причину.
 *
 * Метка поверх статуса - на любом этапе, кроме закрытых (409 `shipment_closed`).
 */
export const postApiShipmentsByIdDelayMutation = (options?: Partial<Options<PostApiShipmentsByIdDelayData>>): UseMutationOptions<PostApiShipmentsByIdDelayResponse, PostApiShipmentsByIdDelayError, Options<PostApiShipmentsByIdDelayData>> => {
    const mutationOptions: UseMutationOptions<PostApiShipmentsByIdDelayResponse, PostApiShipmentsByIdDelayError, Options<PostApiShipmentsByIdDelayData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiShipmentsByIdDelay({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Отмечает шаг согласования выполненным или снимает отметку.
 *
 * Только на «Согласовании» до передачи в 1С; шаги - по порядку, снятие снимает и следующие. Пока все
 * три не отмечены, передача в 1С закрыта.
 */
export const putApiShipmentsByIdApprovalStepsMutation = (options?: Partial<Options<PutApiShipmentsByIdApprovalStepsData>>): UseMutationOptions<PutApiShipmentsByIdApprovalStepsResponse, PutApiShipmentsByIdApprovalStepsError, Options<PutApiShipmentsByIdApprovalStepsData>> => {
    const mutationOptions: UseMutationOptions<PutApiShipmentsByIdApprovalStepsResponse, PutApiShipmentsByIdApprovalStepsError, Options<PutApiShipmentsByIdApprovalStepsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiShipmentsByIdApprovalSteps({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Отмечает документ отгрузки подготовленным или снимает отметку.
 *
 * Чек-лист менеджера, переходы не блокирует; у закрытой отгрузки - 409 `shipment_closed`.
 * Документ на товар - с продуктом из строк отгрузки, на отгрузку целиком - без продукта.
 */
export const putApiShipmentsByIdDocumentsMutation = (options?: Partial<Options<PutApiShipmentsByIdDocumentsData>>): UseMutationOptions<PutApiShipmentsByIdDocumentsResponse, PutApiShipmentsByIdDocumentsError, Options<PutApiShipmentsByIdDocumentsData>> => {
    const mutationOptions: UseMutationOptions<PutApiShipmentsByIdDocumentsResponse, PutApiShipmentsByIdDocumentsError, Options<PutApiShipmentsByIdDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiShipmentsByIdDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiShipmentsByIdVolumeAnalysisQueryKey = (options: Options<GetApiShipmentsByIdVolumeAnalysisData>) => createQueryKey('getApiShipmentsByIdVolumeAnalysis', options);

/**
 * Анализ объёма: количество продуктов отгрузки против прошлых поставок клиента.
 */
export const getApiShipmentsByIdVolumeAnalysisOptions = (options: Options<GetApiShipmentsByIdVolumeAnalysisData>) => queryOptions<GetApiShipmentsByIdVolumeAnalysisResponse, GetApiShipmentsByIdVolumeAnalysisError, GetApiShipmentsByIdVolumeAnalysisResponse, ReturnType<typeof getApiShipmentsByIdVolumeAnalysisQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiShipmentsByIdVolumeAnalysis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiShipmentsByIdVolumeAnalysisQueryKey(options)
});

export const getApiShipmentsByIdInvoiceQueryKey = (options: Options<GetApiShipmentsByIdInvoiceData>) => createQueryKey('getApiShipmentsByIdInvoice', options);

/**
 * Счёт на оплату заказа 1С, созданного по отгрузке, - PDF для скачивания.
 *
 * Не JSON, поэтому действие возвращает файл и объявляет свой 200 (design-guidelines/http-api.md,
 * «Контроллер»). Нет заказа или счёт ещё формируется - 404 `shipment_invoice_not_found`; есть ли счёт,
 * видно в карточке (`invoice`).
 */
export const getApiShipmentsByIdInvoiceOptions = (options: Options<GetApiShipmentsByIdInvoiceData>) => queryOptions<GetApiShipmentsByIdInvoiceResponse, GetApiShipmentsByIdInvoiceError, GetApiShipmentsByIdInvoiceResponse, ReturnType<typeof getApiShipmentsByIdInvoiceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiShipmentsByIdInvoice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiShipmentsByIdInvoiceQueryKey(options)
});

/**
 * «Сформировать заказ в 1С»: отгрузка «в пути», команда уходит процессом; повтор после отказа - тоже сюда.
 *
 * Исход приходит позже событием из 1С: карточку опрашивают, пока передача «в пути».
 */
export const postApiShipmentsByIdHandoverMutation = (options?: Partial<Options<PostApiShipmentsByIdHandoverData>>): UseMutationOptions<PostApiShipmentsByIdHandoverResponse, PostApiShipmentsByIdHandoverError, Options<PostApiShipmentsByIdHandoverData>> => {
    const mutationOptions: UseMutationOptions<PostApiShipmentsByIdHandoverResponse, PostApiShipmentsByIdHandoverError, Options<PostApiShipmentsByIdHandoverData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiShipmentsByIdHandover({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * «Запросить исход» из «нет ответа от 1С»: та же команда уходит ещё раз.
 */
export const postApiShipmentsByIdHandoverRequestOutcomeMutation = (options?: Partial<Options<PostApiShipmentsByIdHandoverRequestOutcomeData>>): UseMutationOptions<PostApiShipmentsByIdHandoverRequestOutcomeResponse, PostApiShipmentsByIdHandoverRequestOutcomeError, Options<PostApiShipmentsByIdHandoverRequestOutcomeData>> => {
    const mutationOptions: UseMutationOptions<PostApiShipmentsByIdHandoverRequestOutcomeResponse, PostApiShipmentsByIdHandoverRequestOutcomeError, Options<PostApiShipmentsByIdHandoverRequestOutcomeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiShipmentsByIdHandoverRequestOutcome({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiSystemVersionQueryKey = (options?: Options<GetApiSystemVersionData>) => createQueryKey('getApiSystemVersion', options);

/**
 * Возвращает метку сборки работающего хоста.
 *
 * Нужен, чтобы отличить «стенд не обновился» от «изменение не работает» без захода на сервер.
 */
export const getApiSystemVersionOptions = (options?: Options<GetApiSystemVersionData>) => queryOptions<GetApiSystemVersionResponse, GetApiSystemVersionError, GetApiSystemVersionResponse, ReturnType<typeof getApiSystemVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiSystemVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiSystemVersionQueryKey(options)
});

export const getApiWarehousesQueryKey = (options?: Options<GetApiWarehousesData>) => createQueryKey('getApiWarehouses', options);

/**
 * Возвращает склады по наименованию; по умолчанию - действующие.
 */
export const getApiWarehousesOptions = (options?: Options<GetApiWarehousesData>) => queryOptions<GetApiWarehousesResponse, GetApiWarehousesError, GetApiWarehousesResponse, ReturnType<typeof getApiWarehousesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiWarehouses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiWarehousesQueryKey(options)
});

export const getApiWarehousesByIdAvailableStockQueryKey = (options: Options<GetApiWarehousesByIdAvailableStockData>) => createQueryKey('getApiWarehousesByIdAvailableStock', options);

/**
 * Возвращает свободный остаток продуктов на складе - по копии остатков 1С, для строк формы отгрузки.
 *
 * Каждый запрошенный продукт - в ответе; остаток неизвестен - `availableQuantity: null`.
 */
export const getApiWarehousesByIdAvailableStockOptions = (options: Options<GetApiWarehousesByIdAvailableStockData>) => queryOptions<GetApiWarehousesByIdAvailableStockResponse, GetApiWarehousesByIdAvailableStockError, GetApiWarehousesByIdAvailableStockResponse, ReturnType<typeof getApiWarehousesByIdAvailableStockQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiWarehousesByIdAvailableStock({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiWarehousesByIdAvailableStockQueryKey(options)
});
